import { useEffect, useState } from "react";
import { useLocalSearchParams, useRouter } from "expo-router";

export function useFlyoutFromParams(paramName: string = "panel") {
  const router = useRouter();
  const params = useLocalSearchParams();
  const paramValue = params[paramName];
  const hasParam = typeof paramValue === "string" && !!paramValue;

  const [visible, setVisible] = useState(hasParam);

  useEffect(() => {
    setVisible(hasParam);
  }, [hasParam]);

  const close = () => {
    setVisible(false);
    router.setParams({ [paramName]: undefined } as any);
  };

  return { visible, setVisible, hasParam, close };
}
